module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#rss",
      toString: function () {
        return this.url;
      }
    }